import { Injectable, Injector } from '@angular/core';
import { Cache, HttpDataService } from '../../core';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class LicenseSessionsService extends HttpDataService {
  public LICENSE_LOG_ID = 'LICENSE_SESSIONS_LOG_LIST';
  protected reportData: Cache;

  constructor(protected injector: Injector) {
    super(injector, '/summaries/licenses');
  }

  loadReportData(licenseId: string): Promise<any> {
    this.reportData = null;
    return this.getReportData(licenseId).then((reportData) => {
      this.reportData = new Cache(reportData);
      return this.reportData;
    });
  }

  getFetchUrl(options?: any) {
    return `${this.baseUrl}/${options.licenseId}/sessions`;
  }

  getReportData(licenseId: string): Promise<any> {
    let url;
    url = `${this.baseUrl}/${licenseId}/sessions`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions()))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }

  getAttr(attr) {
    return this[attr];
  }
}
